import React, { useState } from "react";
import { X } from "lucide-react";
import { getStatusClass } from "../Layout/StatusStyle";
import EditDetail from "./EditDetail";

const DetailBox = ({
  handleClose,
  selectedObject,
  editIconVisibility = true,
}) => {
  const [openEditBox, setOpenEditBox] = useState(false);
  const handleEdit = () => {
    setOpenEditBox(true);
  };
  return (
    <>
      <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
        <div className="bg-white rounded-[20px] lg:w-[60vw] w-[80vw] max-h-[90vh] p-6 relative flex flex-col">
          <button
            onClick={handleClose}
            className="absolute -top-5 -right-8 sm:-right-10 bg-white rounded-full p-1 sm:p-2 shadow-md"
          >
            <X className="w-6 h-6 text-gray-600 hover:text-gray-800" />
          </button>
          <div>
            <div className="flex justify-between">
              <h2 className="text-3xl font-bold mb-3 text-text1">
                Detail info
              </h2>
              {editIconVisibility && (
                <div>
                  <button
                    className="text-white text-sm bg-primary px-4 py-3 rounded-md"
                    onClick={handleEdit}
                  >
                    Edit
                  </button>
                </div>
              )}
            </div>

            <hr className="mt-4" />
          </div>
          <div className="mb-3">
            <div className="flex justify-between pt-3 pb-2.5">
              <p className="font-medium text-base text-text1">
                Patient details
              </p>
            </div>
            {[
              { label: "Patient name", value: selectedObject.patientname },
              { label: "Patient email", value: selectedObject.patientemail },
              {
                label: "Mobile Number",
                value: selectedObject.patientnumber,
              },
            ].map(({ label, value }) => (
              <div key={label} className="flex justify-between py-3">
                <p className="font-medium text-base text-text3">{label}</p>
                <p className="font-medium text-base text-text1 text-right">
                  {value || ""}
                </p>
              </div>
            ))}
          </div>
          <hr />
          <div className="mb-3">
            <div className="flex justify-between pt-3 pb-2.5">
              <p className="font-medium text-base text-text1">
                Product details
              </p>
            </div>
            {[
              { label: "Doctor name", value: selectedObject.doctorsname },
              { label: "Product code", value: selectedObject.product_id },
              {
                label: "Product name",
                value: selectedObject.product_name,
              },
              {
                label: "Quantity",
                value: selectedObject.quantity,
              },
              {
                label: "Status",
                value: selectedObject.tracking_status, //FIXME: change correct parameter name
              },
            ].map(({ label, value }) => (
              <div key={label} className="flex justify-between py-3">
                <p className="font-medium text-base text-text3">{label}</p>
                <p className="font-medium text-base text-text1 text-right">
                  {label === "Status" ? (
                    <span className={getStatusClass(value)}>{value} </span>
                  ) : (
                    value || ""
                  )}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
      {openEditBox && <EditDetail selectedObject={selectedObject} closeModal={() => setOpenEditBox(false)} />}
    </>
  );
};

export default DetailBox;
